// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2sl8p","inputDescription":"styles_inputDescription__2MCbj"};